import S from './EventCancelModal.module.scss';
import { Text } from '@components/Text';
import { Input } from '@components/Input';
import { InputSwitch } from 'primereact/inputswitch';
import { FC, useCallback, useState } from 'react';
import clsx from 'clsx';
import { RedesignButton } from '@components/RedesignButton';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { closeCurrentModalAction } from 'src/redesign/features/Modals/store/reducer';
import { useForm } from 'react-hook-form';
import { showNotification } from 'src/redesign/features/Toast/store/actions';
import { getCurrentEventSelector } from 'src/redesign/features/Events/store/selectors';
import { FormField } from 'wix-style-react';

type FormValues = {
  emailSubject?: string;
  emailNote?: string;
  refundNote?: string;
};

type EventCancelModalProps = {
  handleSubmit?: (value: string) => () => void;
};

export const EventCancelModal: FC<EventCancelModalProps> = ({ handleSubmit }) => {
  const [sendEmailActive, setSendEmailActive] = useState(true);
  const [sendRefundActive, setSendRefundActive] = useState(false);
  const dispatch = useAppDispatch();
  const currentEvent = useAppSelector(getCurrentEventSelector);

  const cancelEventCallback = useCallback(() => {
    if (!currentEvent?.id) return;
    handleSubmit && handleSubmit('cancelled');
    dispatch(
      showNotification({
        detail: 'Event Cancelled',
        severity: 'success',
        life: 5000,
      }),
    );
    dispatch(closeCurrentModalAction());

    // history.push('/events');
  }, [currentEvent?.id, dispatch, handleSubmit]);

  const { register, handleSubmit: handleSubmitForm } = useForm<FormValues>();

  const onSubmit = (data: FormValues) => {};

  return (
    <div className={S.eventCancelModal}>
      <div className={S.disclaimer}>
        <Text bold>Cancel Event</Text>
        <Text>
          When you cancel an event, attendees can be automatically notified. This action cannot be
          undone.
        </Text>
      </div>
      <form className={S.form} onSubmit={handleSubmitForm(onSubmit)}>
        <div className={S.sendEmailForm}>
          <div className={S.switcherContainer}>
            <FormField label="Notify Attendees">
              <InputSwitch
                color="#9D25DC1A"
                id="send-email-subject-switcher"
                checked={sendEmailActive}
                pt={{
                  root: {
                    height: '20px',
                  },
                  slider: {
                    className: clsx(S.switcher, { [S.checked]: sendEmailActive }),
                  },
                }}
                onChange={() => setSendEmailActive((prevState) => !prevState)}
              />
            </FormField>
          </div>

          {sendEmailActive && (
            <>
              <FormField label="Email Subject">
                <Input
                  name="emailSubject"
                  labelHook="send-email-subject-field"
                  placeholder="Enter a subject for the email notification"
                  register={register}
                />
              </FormField>
              <FormField label="Message">
                <Input
                  name="emailNote"
                  as="textarea"
                  textAreaProps={{
                    autoResize: true,
                    placeholder:
                      'Explain to your attendees why the event is cancelled and any next steps they should take',
                    rows: 5,
                  }}
                  register={register}
                  labelHook="send-email-note-field"
                />
              </FormField>
            </>
          )}
        </div>
        <div className={S.controlsContainer}>
          <RedesignButton text onClick={() => dispatch(closeCurrentModalAction())}>
            <Text bold color="brand-400">
              Go Back
            </Text>
          </RedesignButton>
          <RedesignButton
            type="submit"
            onClick={() => {
              cancelEventCallback();
            }}
            variation="primary"
            height={44}
          >
            <Text bold color="white-100">
              Cancel Event
            </Text>
          </RedesignButton>
        </div>
      </form>
    </div>
  );
};
